import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import _localize from 'scaleflow/utils/localize';

export default class FormatCurrencyHelper extends Helper {
  @service organisation;
  @service intl;

  compute([value, suffix = '', prefix = '']) {
    const locale = this.intl.t('currency.locale');
    return _localize(value, suffix, prefix, locale);
  }
}
